import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Logger, LoggerFactory } from './logger.service';
import { SnackBarService } from './snack-bar.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private readonly logger: Logger;

  constructor(
    private injector: Injector,
    public readonly loggerFactory: LoggerFactory,
  ) {
    this.logger = loggerFactory.get('HttpErrorInterceptor');
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      // retry(1),
      catchError((error: HttpErrorResponse) => {
        this.logger.error('Server error intercepted: ' + JSON.stringify(error));
        const snackbarService: SnackBarService = this.injector.get(SnackBarService);
        /*
         * TODO: Snackbar should be more developed than this, and added when the test period on Rollbar is run to see how
         * many errors we have
         *
         * const snackbarService:SnackBarService = this.injector.get(SnackBarService);
         * snackbarService.error( 'generic.error');
         */

        return throwError(error);
      }),
    );
  }
}
